import { render } from "./AssessmentResults.vue?vue&type=template&id=dc94154c"
import script from "./AssessmentResults.vue?vue&type=script&lang=js"
export * from "./AssessmentResults.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__